<template>
    <div class="page">
        <Breadcrumb title="交易中心" :breadcrumb="breadcrumb" />
        <detail-content :title="title">
            <div class="table" v-for="(item,index) of detail" :key="index">
                <Table :data="billInfo" :header="item.tableHeader" />
            </div>
        </detail-content>
        <div class="error-btn">
            <el-button class="back" @click="goBack">返回</el-button>
            <el-button v-if="billInfo.status===3" class="update" type="primary" @click="refund">申请退款</el-button>
        </div>
    </div>
</template>

<script>
import { detail } from '@trading/static/data.js';
import { breadcrumb } from '@/mixins/index.js';
import Table from '@trading/components/table.vue';
import DetailContent from '@trading/components/detail-content.vue';
import { mapActions, mapState } from 'vuex';
export default {
  name: 'detail',
  mixins: [breadcrumb],
  components: { Table, DetailContent },
  data() {
    return {
      detail: [],
      detailTable: {},
    };
  },
  computed: {
    title() {
      return detail.title.get(this.$route.name);
    },
    ...mapState({
      billInfo: (state) => state.trading.billInfo,
    }),
  },
  methods: {
    ...mapActions('trading', ['getBillById']),
    // 返回
    goBack() {
      this.$router.back(-1);
    },
    //申请退款
    refund() {
      this.$router.push({
        name: 'trading/applyRefund',
        query: { id: this.billInfo.id },
      });
    },
  },
  created() {
    this.detail = detail.detailTable.get(this.$route.name);
    this.getBillById({ id: this.$route.query.id });
  },
};
</script>

<style lang="less" scoped>
@import '~@reconciliation/static/common.less';
// 重写 element-ui 样式
/deep/.table-header-cell {
  background: #f8f8f8 !important;
  font-weight: 400;
  color: @font-color-secondary;
}
/deep/.el-table td {
  border-color: #f0f0f0;
}
/deep/.el-table--border th {
  border-color: #f0f0f0;
}
// 重写组件内样式
/deep/.error {
  color: @danger-color !important;
}

.page {
  height: 100%;
  .box_column();
}
.table {
  margin-top: 1.5em;
  .flex_layout(row, center, flex-start);
}
.error-list {
  margin-top: 15px;
  .table {
    padding: 0 40px;
  }
}
.btn-container {
  .flex_layout(row, space-between, flex-start);
  flex-wrap: wrap;
  color: @primary-blue;
  .btn {
    cursor: pointer;
    &:nth-child(2) {
      margin-right: 1em;
    }
    &:nth-child(3) {
      margin-top: 0.7em;
    }
  }
}
.error-btn {
  background: #fff;
  padding-bottom: 34px;
  text-align: center;
  .el-button {
    width: 100px;
    height: 40px;
    font-size: 14px;
    font-family: Helvetica;
    font-weight: 400;
    color: #4359b7;
    border-color: @primary-blue;
    margin-right: 20px;
  }
  .update {
    background: #f5f5f5;
    border: none;
  }
  .back {
    color: #fff;
    background: @primary-blue;
  }
}
</style>
